import React, { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";

function FacebookPostPreview(fbUrl) {
  const [previewData, setPreviewData] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (fbUrl) { dispatch(getPreviewData(fbUrl)); }
  }, []);

  const getPreviewData = (params = {}) => {
    const encodedParams = new URLSearchParams(params).toString();
    const endpoint = `/api/v1/fb_preview_data?${encodedParams}`;
    return () => {
      fetch(endpoint, {
        method: "GET",
        credentials: "same-origin",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json"
        }
      })
        .then((res) => res.json())
        .then(
          (data) => setPreviewData(data),
          (_err) => setPreviewData(null)
        ).catch(() => {});
    };
  };

  if (!previewData || ENV['INTEGRATION'] !== '2') { return null; }

  return (
    <a className='row fb-ad-row justify-content-between' href={fbUrl.url} target='_blank'>
      <div className='col-3 text-center'>
        { previewData.image_url && <img className='fb-ad-img' src={previewData.image_url} alt="Facebook ad" /> }
      </div>
      <div className='col-9'>
        <h6>{`Facebook - ${previewData.from}`}</h6>
        <p className='fb-ad-description'>{previewData.description}</p>
      </div>
    </a>
  );
}

export default FacebookPostPreview;
